import { render, staticRenderFns } from "./AuctionImportantInformationLink.vue?vue&type=template&id=8f1e3b3e&scoped=true"
import script from "./AuctionImportantInformationLink.vue?vue&type=script&lang=js"
export * from "./AuctionImportantInformationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e3b3e",
  null
  
)

export default component.exports